import { render, staticRenderFns } from "./AddTenant.vue?vue&type=template&id=5720a9f2&"
import script from "./AddTenant.vue?vue&type=script&lang=js&"
export * from "./AddTenant.vue?vue&type=script&lang=js&"
import style0 from "./AddTenant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports